module.exports = __webpack_public_path__ + "static/img/weixiao-dark.d59fb3ab.svg";